/**
 * @copyright 2019 @ DigiNet
 * @author tranghoang
 * @create 2019/01/23 16:50
 * @update 2019/10/28 16:50 by TRIHAO
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Config from "../../config";
import {Select, Button} from "@material-ui/core";
import {TextField} from "../common/form-material";

class Paging extends Component {
    constructor(props) {
        super(props);

        this.state = {
            totalItems: props.totalItems || 0,
            itemPerPage: props.itemPerPage,
            currentPage: props.currentPage && props.currentPage !== -1 ? props.currentPage : 0,
            listPerPage: props.listPerPage || [10, 15, 20, 30, 50],
            disableFirst: true,
            disablePrev: true,
            disableNext: !(props.totalItems > props.itemPerPage),
            disableLast: !(props.totalItems > props.itemPerPage),
            typeShort: props.typeShort
        };

        this.timeout = null;
    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (this.props.totalItems !== nextProps.totalItems || (this.props.skipPerPage !== nextProps.skipPerPage && nextProps.skipPerPage === 0)) {
            const lastPage = this.getLastPage(nextProps.totalItems, this.state.itemPerPage);
            const _initCurrentPage = ((nextProps.currentPage && nextProps.currentPage !== -1) || nextProps.currentPage === 0)? nextProps.currentPage : this.state.currentPage;
            const currentPage = _initCurrentPage + 1 > lastPage ? lastPage - 1 : _initCurrentPage;
            this.setState({
                totalItems: nextProps.totalItems,
                listPerPage: nextProps.listPerPage,
                disableNext: nextProps.totalItems <= (currentPage + 1) * nextProps.itemPerPage,
                disableLast: nextProps.totalItems <= (currentPage + 1) * nextProps.itemPerPage,
            });
            if (_initCurrentPage !== -1) {
                this.setState({
                    currentPage: currentPage,
                });
            }
            if (_initCurrentPage + 1 > lastPage) {
                this.onChangePage(lastPage - 1);
            }
        }
    }
    getLastPage(totalItems, itemPerPage) {
        let lastPage = 0;

        if (totalItems && totalItems >= 0 && itemPerPage && itemPerPage > 0 ) {
            lastPage = Math.ceil(totalItems / itemPerPage);
                return lastPage;
        }

        return lastPage + 1;
    }
    onChangePage(page) {
        const {totalItems, itemPerPage} = this.state;
        const lastPage = this.getLastPage(totalItems, itemPerPage);

        if (page < 0) page = 0;
        if (page >= lastPage) page = lastPage - 1;

        let disableFirst = false;
        let disablePrev = false;
        let disableNext = false;
        let disableLast = false;

        // If last page = 1. Disable all
        if (lastPage === 1) {
            disableFirst = true;
            disablePrev = true;
            disableNext = true;
            disableLast = true;
        }

        // If current page = last page. Disable Next and Last
        if (page + 1 >= lastPage) {
            disableNext = true;
            disableLast = true;
        }

        // If current page = 0. Disable Previous and First
        if (0 === page) {
            disableFirst = true;
            disablePrev = true;
        }

        this.setState({
            currentPage: page,
            disableFirst: disableFirst,
            disablePrev: disablePrev,
            disableNext: disableNext,
            disableLast: disableLast
        }, () => {
            if (this.props.onChangePage) this.props.onChangePage(page);
        });
    }

    onChangePerPage(per) {
        const {totalItems} = this.state;
        const lastPage = this.getLastPage(totalItems, per);

        per = parseInt(per, 10);

        let disableNext = false;
        let disableLast = false;

        // If last page = 1. Disable all
        if (lastPage === 1) {
            disableNext = true;
            disableLast = true;
        }

        this.setState({
            itemPerPage: per,
            currentPage: 0,
            disableFirst: true,
            disablePrev: true,
            disableNext: disableNext,
            disableLast: disableLast
        }, () => {
            if (this.props.onChangePerPage) this.props.onChangePerPage(per);
        });
    }

    onTypePaging = (e) => {
        clearTimeout(this.timeout);
        const {totalItems, itemPerPage} = this.state;
        const lastPage = this.getLastPage(totalItems, itemPerPage);
        const value = e.target.value;
        const page = (!value || parseInt(value) < 0) ? 1 : (parseInt(value) > lastPage ? lastPage : parseInt(value));
        this.setState({currentPage: page - 1});
        this.timeout = setTimeout( () => {
            this.onChangePage(page-1);
        }, 500);
    };

    render() {
        const {currentPage, totalItems, itemPerPage, disablePrev, disableNext,typeShort} = this.state;
        const {className} = this.props;
        const lastPage = this.getLastPage(totalItems, itemPerPage);

        if (!this.props.totalItems) return null;

        if(this.refs['input-page'] && parseInt(this.refs['input-page'].value) !== (currentPage+1)){
            this.refs['input-page'].value = currentPage + 1;
        }
        return (
            <div ref={this.props.reference} className={"paging " + className} id={"paging"}>
                <div>
                    <Button className={"prev"}
                            disabled={disablePrev}
                            onClick={()=>{this.onChangePage(currentPage - 1)}}>
                        <i className="far fa-chevron-left text-bold" />
                    </Button>
                </div>
                <TextField
                    className="pageOf text-center"
                    ref={'input-page'}
                    type={"number"}
                    fullWidth={false}
                    style={{minWidth:"23px"}}
                    value={currentPage ? String(currentPage + 1) : "1"}
                    onChange={(e)=>this.onTypePaging(e)}
                /> /&nbsp;{lastPage}
                <div>
                    <Button className={"next mgl5"}
                            disabled={disableNext}
                            onClick={()=>{this.onChangePage(currentPage + 1)}}>
                        <i className="far fa-chevron-right text-bold" />
                    </Button>
                </div>
                {typeShort &&<span className={"slash"}>|</span>}&nbsp;
                {!typeShort && <span className="txt-line-number mgl15">{Config.lang("ERP_So_dong")}</span>}

                <Select native
                        className="pagePer"
                        variant={"outlined"}
                        margin={'dense'}
                        defaultValue={this.state.itemPerPage}
                        onChange={(e) => this.onChangePerPage(e.target.value)}>
                    {this.state.listPerPage && this.state.listPerPage.map((o, i) =>{
                        return (<option key={i} value={o} >{o}</option>);
                    })}
                </Select>
                {typeShort && <span className={"slash"}>&nbsp;|&nbsp;</span>}
                <span className={"hide-mobile " + (!typeShort ? "mgl5" : "")}><b> {!typeShort ? Config.lang("ERP_Tong") + ':' : ''} {totalItems}</b></span>
            </div>
        );
    }
}

Paging.propTypes = {
    reference: PropTypes.any,
    totalItems: PropTypes.number,
    itemPerPage: PropTypes.number,
    currentPage: PropTypes.number,
    listPerPage: PropTypes.array,
    typeShort:PropTypes.bool,
    className: PropTypes.string,

    onChangePage: PropTypes.func,
    onChangePerPage: PropTypes.func,
};

export default Paging;
